import api from '@/apis/di/accountAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';
import {getCurrentInstance} from 'vue';

// Combo grid tài khoản ngầm định
export const useAccountComboGridv2 = (comboboxDataRemote, comboboxLoadData) => {
  const {proxy} = getCurrentInstance();
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onAccountComboboxv2LoadData = (payload, row, column) => {
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'account_number';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };
  // config columns combo
  const accountCombov2Config = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Số tài khoản',
        dataField: 'account_number',
        width: 120,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên tài khoản',
        dataField: 'account_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 300,
      },
      {
        title: 'Bậc',
        dataField: 'grade',
        width: 50,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'account_number',
    valueField: 'account_number',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onAccountComboboxv2LoadData,
  };
  return {
    accountCombov2Config,
    onAccountComboboxv2LoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
